// src/components/Insights/InsightDetail.tsx
import type { InsightPost } from "../../data/posts";

interface InsightDetailProps {
  insight: InsightPost | null;
}

const InsightDetail: React.FC<InsightDetailProps> = ({ insight }) => {
  if (!insight) {
    return (
      <div className="border border-dashed border-line-strong p-6 text-sm text-muted">
        <p>Select an insight on the left to read it.</p>
      </div>
    );
  }

  return (
    <div className="surface-card p-6 sm:p-7 space-y-6">
      {/* Header */}
      <div>
        <p className="kicker mb-2">{insight.tags[0]}</p>
        <h2 className="font-display text-xl sm:text-2xl font-semibold text-ink mb-2">
          {insight.title}
        </h2>
        <p className="font-mono text-xs text-muted tracking-wide">
          {new Date(insight.date)
            .toLocaleDateString("en-GB", {
              year: "numeric",
              month: "short",
              day: "2-digit",
            })
            .toUpperCase()}{" "}
          · {insight.readingTime.toUpperCase()}
        </p>
      </div>

      {/* Summary */}
      <div>
        <h3 className="kicker mb-1.5">Overview</h3>
        <p className="text-sm text-ink">{insight.excerpt}</p>
      </div>

      {/* Content */}
      <div>
        <h3 className="kicker mb-2">Full insight</h3>
        <div className="space-y-3 text-sm leading-relaxed text-ink">
          {insight.content.split("\n\n").map((paragraph, idx) => (
            <p key={idx}>{paragraph}</p>
          ))}
        </div>
      </div>

      {/* Tags */}
      <div className="pt-4 border-t border-line flex flex-wrap gap-2">
        {insight.tags.map((tag) => (
          <span key={tag} className="tag-chip">
            {tag}
          </span>
        ))}
      </div>
    </div>
  );
};

export default InsightDetail;
